import { Route, Routes } from "react-router-dom";
import "./App.css";
import NavBar from "./components/NavBar";
import Home from "./pages/home/Home";
import Login from "./pages/auth/Login";
import { AuthContextProvider } from "./context/AuthContext";
import ProtectedRoute from "./pages/auth/ProtectedRoute";
import Inventory from "./pages/inventory/Inventory";
import Todo from "./pages/todo/Todo";
import Example from "./pages/several/Temp";
import Register from "./pages/register/Register";
import PettyCash from "./pages/pettyCash/PettyCash";
import Charts from "./pages/charts/Charts";
import Settings from "./pages/settings/Settings";
// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";
import { useState } from "react";
import Cart from "./pages/cart/Cart";
import Right from "./pages/several/Right";
import SubCollection from "./pages/settings/SubCollection";
import { getInitColorSchemeScript } from "@mui/joy/styles";
import Po from "./pages/po/Po";
import PoMain from "./pages/po/PoMain";
import Products from "./pages/shopify/Products";
import NotFound from "./components/NotFound";
import IphoneInv from "./pages/app/IphoneInv";

function App() {
  const [colorMode, setColorMode] = useState(true);

  // const darkTheme = createTheme({
  //   palette: {
  //     mode: colorMode ? "dark" : "light",
  //   },
  // });

  return (
    <div className="App">
      <header className="">
        {/* <div className="container"> */}
        {getInitColorSchemeScript()}
        <div>
          {/* <ThemeProvider theme={darkTheme}>
            <CssBaseline /> */}
          <AuthContextProvider>
            <NavBar colorMode={colorMode} setColorMode={setColorMode} />

            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/e" element={<Example />} />
              <Route path="/r" element={<Right />} />
              <Route path="*" element={<NotFound />} />
              <Route
                path="/home"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inventory"
                element={
                  <ProtectedRoute>
                    <Inventory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/iphone"
                element={
                  <ProtectedRoute>
                    <IphoneInv />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/todo"
                element={
                  <ProtectedRoute>
                    <Todo />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/shopify"
                element={
                  <ProtectedRoute>
                    <Products />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sc"
                element={
                  <ProtectedRoute>
                    <SubCollection />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cart"
                element={
                  <ProtectedRoute>
                    <Cart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pomain"
                element={
                  <ProtectedRoute>
                    <PoMain />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/po"
                element={
                  <ProtectedRoute>
                    <Po />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/register"
                element={
                  <ProtectedRoute>
                    <Register />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/petty"
                element={
                  <ProtectedRoute>
                    <PettyCash />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/charts"
                element={
                  <ProtectedRoute>
                    <Charts />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AuthContextProvider>
          {/* </ThemeProvider> */}
        </div>
      </header>
    </div>
  );
}

export default App;
